var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2280,
    height: 564,
    viewBox: "0 0 2280 564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.294922 1.10091L185.594 1.43813L186.865 252.831L327.743 1.5548L503.198 1.90499L514.403 243.558L620.704 2.08656L817.546 2.46268L558.475 561.239L350.077 560.824L350.427 327.563L242.415 563.989L19.0881 563.639L0.294922 1.10091ZM904.625 1.10091L1435.81 1.99582L1495.11 122.835L1301.15 274.789L1424.89 560.681L1216.34 560.253L1102.67 261.145L1213.75 160.396L1056.45 160.071L932.652 562.303L730.921 562.017L904.625 1.10091ZM1625.24 2.46268L1812.98 0.0244141L1907.07 129.216L2033.66 0.0244141L2279.71 0.750718L2007.72 293.245L2191.78 560.902L1936.06 561.109L1851.88 428.636L1717.8 560.681L1464.69 560.085L1765.43 252.624L1625.24 2.46268Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrx);
export default __webpack_public_path__ + "static/media/WRX.5200aee1d18d7d8f36105394e6d86fc4.svg";
export { ForwardRef as ReactComponent };